import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { LayoutGroup } from 'framer-motion';
import { Children, forwardRef } from 'react';
/**
 * Used to layout and display pagination bullets.
 */
export const Pagination = forwardRef(({ as: Component = Stack, variant, items, ...props }, ref) => (_jsx(Component, { justify: "center", align: "center", ...props, ref: ref, children: _jsx(LayoutGroup, { children: Children.map(items.map((item) => item({ variant })), (item) => item) }) })));
Pagination.displayName = 'Pagination';
